export default __webpack_public_path__ + "static/media/avatar_35.722777b4.png";